module.exports = __webpack_public_path__ + "static/media/clouds_default_mirrored.859fd3cf.jpeg";